var LGFG = LGFG || {};
LGFG.WF = LGFG.WF || {};

LGFG.WF.StaticMap = LGFG.WF.StaticMap || (function () {

    var init = function (elementSelector) {

        var lat = parseFloat($(elementSelector).data('lat'));
        var lng = parseFloat($(elementSelector).data('lng'));
        var url = `https://maps.googleapis.com/maps/api/staticmap?center=${lat},${lng}&zoom=5&size=600x600&maptype=roadmap&markers=${lat},${lng}&key=AIzaSyC6q7V8LgmgnKkwcFNxMiKJ8pOjYJlkm_w`

        $(elementSelector)
            .css('background-image', `url('${url}')`)
            .css('padding-top', `75%`)
            .css('background-position', 'center 45%');
    };

    return {
        init: init
    };
})();